import React, { useState } from 'react'
import { WifiOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useSync } from '../../../../hooks/useSync'
import { ServerStatusDialog } from './ServerStatusDialog'
import './OfflineIndicator.scss'
import { WithTooltip } from '@/src/renderer/components/ui/tooltip'

/**
 * Compact offline badge shown in the LifeSpacesSidebar when the server is unreachable.
 *
 * Displays a WifiOff icon with "Offline" label. Clicking opens the {@link ServerStatusDialog}
 * with retry countdown and detail cards.
 *
 * Only renders with active Geräte-Sync and when `!isOnline || !isSupabaseReachable`.
 * Ohne Geräte-Sync wartet nichts auf die Verbindung (CONTEXT.md, **Offline-Symbol**).
 */
export const OfflineIndicator: React.FC = () => {
  const { t } = useTranslation()
  const { isOnline, isSupabaseReachable, syncActive } = useSync()
  const [dialogOpen, setDialogOpen] = useState(false)

  if (!syncActive || (isOnline && isSupabaseReachable)) return null

  return (
    <>
      <WithTooltip content={t('sync.serverStatus.title')}>
        <button
          aria-label={t('sync.serverStatus.title')}
          className="offline-indicator"
          onClick={() => setDialogOpen(true)}
        >
          <WifiOff size={16} className="offline-indicator__icon" />
          <span className="offline-indicator__label">{t('sync.offline')}</span>
        </button>
      </WithTooltip>

      <ServerStatusDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  )
}
